import BaseController from './basePlayerController';
import UserAgentDetector from '../../../utils/UserAgentDetector';
import { isIframe } from '../../../utils/isIframe';

export default class ControllerFullScreen extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_FULL_SCREEN: 'full_screen_button',
      EBT_EXIT_FULL_SCREEN: 'exit_full_screen_button',
    };
    this._eEventTypes =  {
      FULL_SCREEN_CLICK: this.getEventName(this._eButtonsTypes.EBT_FULL_SCREEN),
      EXIT_FULL_SCREEN_CLICK: this.getEventName(this._eButtonsTypes.EBT_EXIT_FULL_SCREEN),
    };
    this._eButtonsActions = {
      [this._eButtonsTypes.EBT_FULL_SCREEN]: this.openFullscreen.bind(this),
      [this._eButtonsTypes.EBT_EXIT_FULL_SCREEN]: this.exitFullscreen.bind(this),
    };
    this._eElementsTypes = {
      EET_FULL_SCREEN_BUTTON: this._eButtonsTypes.EBT_FULL_SCREEN,
      EET_EXIT_FULL_SCREEN_BUTTON: this._eButtonsTypes.EBT_EXIT_FULL_SCREEN,
    };

    this.init(container);

    this._updateButton = this._updateButton.bind(this);

    if (!UserAgentDetector.isMobile.android.device || !document.fullscreenEnabled) {
      if (UserAgentDetector.isMobile.android.device) this.checkFullscreenAllows();
      this.hide();
    } else {
      this._updateButton();
      window.addEventListener('fullscreenchange', this._updateButton);
    }
  }

  beforeRemove() {
    super.beforeRemove();
    window.removeEventListener('fullscreenchange', this._updateButton);
  }

  get isFullscreen() {
    return Boolean(document.fullscreenElement
      || document.webkitFullscreenElement
      || document.mozFullScreenElement
      || document.msFullscreenElement);
  }

  checkFullscreenAllows() {
      if (isIframe() && document.featurePolicy && !document.featurePolicy.allowsFeature("fullscreen")) {
        console.warn("Game can't use fullscreen, please add allow=\"fullscreen\" attribute to iframe element");
      }
  }

  openFullscreen() {
    let element = document.documentElement;
    const requestFullscreen = element.requestFullscreen
      || element.mozRequestFullScreen
      || element.webkitRequestFullscreen
      || element.msRequestFullscreen;

    const callFullscreen = () => {
      requestFullscreen && document.fullscreenEnabled && requestFullscreen.call(element, { navigationUI: 'hide' })
        .catch(e => console.error(e));
    }

    clearTimeout(this._fullscreenTimeoutForFirstCall);
    this._fullscreenTimeoutForFirstCall = setTimeout(callFullscreen, 100); // hack: fullscreen can be called only after user action
  }

  exitFullscreen() {
    const exitFullscreen = document.exitFullscreen
      || document.mozCancelFullScreen
      || document.webkitExitFullscreen
      || document.msExitFullscreen;

    exitFullscreen && exitFullscreen.call(document)
      .catch(e => console.error(e));
  }

  _updateButton() {
    this.isFullscreen ? this._showExitButton() : this._showOpenButton();
  }

  _showOpenButton() {
    this.interactiveElements[this._eElementsTypes.EET_FULL_SCREEN_BUTTON].classList.remove('hidden');
    this.interactiveElements[this._eElementsTypes.EET_EXIT_FULL_SCREEN_BUTTON].classList.add('hidden');
  }

  _showExitButton() {
    this.interactiveElements[this._eElementsTypes.EET_FULL_SCREEN_BUTTON].classList.add('hidden');
    this.interactiveElements[this._eElementsTypes.EET_EXIT_FULL_SCREEN_BUTTON].classList.remove('hidden');
  }

  _getMarkup() {
    return `
          <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_FULL_SCREEN_BUTTON]}>
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.66669 33.2667V30.0001C6.66669 13.3334 13.3334 6.66675 30 6.66675H50C66.6667 6.66675 73.3334 13.3334 73.3334 30.0001V50.0001C73.3334 66.6667 66.6667 73.3334 50 73.3334H46.6667" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M43.3333 36.6667L60.0333 19.9333H46.6666" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M60.0334 19.9333V33.3" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M36.6667 53.8333V62.8333C36.6667 70.3333 33.6667 73.3333 26.1667 73.3333H17.1667C9.66669 73.3333 6.66669 70.3333 6.66669 62.8333V53.8333C6.66669 46.3333 9.66669 43.3333 17.1667 43.3333H26.1667C33.6667 43.3333 36.6667 46.3333 36.6667 53.8333Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </button>
         <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_EXIT_FULL_SCREEN_BUTTON]}>
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.66675 33.2667V30.0001C6.66675 13.3334 13.3334 6.66675 30.0001 6.66675H50.0001C66.6667 6.66675 73.3334 13.3334 73.3334 30.0001V50.0001C73.3334 66.6667 66.6667 73.3334 50.0001 73.3334H46.6667" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M60.0325 19.9334L43.3325 36.6667L56.6991 36.6667" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M43.3333 36.6667L43.3333 23.3001" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M36.6667 53.8333V62.8333C36.6667 70.3333 33.6667 73.3333 26.1667 73.3333H17.1667C9.66675 73.3333 6.66675 70.3333 6.66675 62.8333V53.8333C6.66675 46.3333 9.66675 43.3333 17.1667 43.3333H26.1667C33.6667 43.3333 36.6667 46.3333 36.6667 53.8333Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </button>`
  }
}
